(function () {
  angular
    .module('specsguardApp')
    .directive('sgWidgetMultiselect', sgWidgetMultiselect);

  sgWidgetMultiselect.$inject = [];

  function sgWidgetMultiselect () {
    return {
      restrict: 'E',
      templateUrl: 'app-legacy/components/sg-widget/sg-widget-multiselect/sg-widget-multiselect.html'
    };
  };
})();
